import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class ListService {
    constructor(private http: HttpClient) {}

    //Behavior Subject for CustomField
    private customField = new BehaviorSubject("");

    getCustomField(): Observable<any> {
        return this.customField.asObservable();
    }

    setCustomField(field) {
        this.customField.next(field);
    }

    getAllModules() {
        return this.http.get<any>(`${environment.configUrl}LionO360_Object`);
    }

    getAllCustomFields(id) {
        return this.http
            .get<any>(
                `${environment.configUrl}Configuration/CustomAttributes?objectId=${id}`
            )
            .toPromise()
            .then((res) => res);
    }

    getAllCustomFieldTypes(id) {
        return this.http
            .get<any>(
                `${environment.configUrl}Configuration/FormControls?objectId=${id}`
            )
            .toPromise()
            .then((res) => res);
    }

    deletCustomField(id, objId) {
        return this.http
            .delete<any>(
                `${environment.configUrl}Configuration/CustomAttribute/${id}?objectId=${objId}`
            )
            .toPromise()
            .then((res) => res);
    }

    deleteCustomField(reqData) {
        return this.http
            .delete<any>(
                `${environment.configUrl}Configuration/CustomAttribute/${reqData.fieldId}?objectId=${reqData.moduleId}`
            )
            .toPromise()
            .then((res) => res);
    }

    addCustomFieldsConfiguration(obj) {
        return this.http
            .post<any>(
                `${environment.configUrl}Configuration/CustomAttribute`,
                obj
            )
            .toPromise()
            .then((res) => res);
    }

    getAllLevels() {
        return this.http
            .get<any>(`${environment.configUrl}Level`)
            .toPromise()
            .then((res) => res);
    }

    getAllTypes() {
        return this.http
            .get<any>(`${environment.appOrgUrl}Type`)
            .toPromise()
            .then((res) => res);
    }

    getAllCategories() {
        return this.http
            .get<any>(`${environment.appOrgUrl}Category`)
            .toPromise()
            .then((res) => res);
    }

    // getCustomFieldById(id) {
    //   return this.http.get<any>(`${environment.configUrl}Configuration/${id}`)
    //     .toPromise()
    //     .then(res => res);
    // }

    // getCustomFieldById(id, module) {
    //     const baseUrl =
    //         module == "Product"
    //             ? environment.inventoryURl
    //             : module == "Purchases"
    //             ? environment.purchaseURl
    //             : environment.purchaseURl;
    //     return this.http
    //         .get<any>(`${baseUrl}CustomAttribute/${id}`)
    //         .toPromise()
    //         .then((res) => res);
    // }

    getCustomFieldById(id, module) {
        return this.http
            .get<any>(`${environment.inventoryURl}CustomAttribute/${id}`)
            .toPromise()
            .then((res) => res);
    }

    getOrdersCustomFieldById(id) {
        return this.http
            .get<any>(`${environment.inventoryURl}CustomAttribute/${id}`)
            .toPromise()
            .then((res) => res);
    }

    //   getCustomFieldById(id,module) {
    //     const baseUrl = (module=='Product'? environment.inventoryURl: module=='Purchases'? environment.purchaseURl: module=='Orders'? environment.inventorySalesUrl : environment.purchaseURl );
    //     return this.http.get<any>(`${baseUrl}CustomAttribute/${id}`)
    //       .toPromise()
    //       .then(res => res);
    //   }

    //   updateCustomFieldsConfiguration(obj) {
    //     return this.http.put<any>(`${environment.configUrl}Configuration/CustomAttribute`, obj)
    //       .toPromise()
    //       .then(res => res);
    //   }

    updateCustomFieldsConfiguration(obj) {
        return this.http
            .put<any>(
                `${environment.configUrl}Configuration/CustomAttribute`,
                obj
            )
            .toPromise()
            .then((res) => res);
    }
}
